import { get, put } from 'services/api';
import { ICourse } from 'interface/course';

import { decreaseLoading, increaseLoading } from './loading';
import { fetchUpsells } from 'actionCreators/upsells';
import { IS_APP, API_V4_BASE_URL } from 'settings';

export const cleanLesson = () => ({
  type: 'CLEAN_LESSON',
});

export const updateWatchedLesson = (data: boolean, lessonID: any) => ({
  type: 'UPDATE_WATCHED_LESSON',
  data,
  lessonID,
});

export const updateWatchedLessonOnModule = (data: boolean, lessonID: any) => ({
  type: 'UPDATE_WATCHED_LESSON_ON_MODULE',
  data,
  lessonID,
});

const startLesson = (lessonID: number, course: ICourse) => async (dispatch: any, getState: Function) => {
  const updated_progress = getState().lesson.updated_progress;
  if (updated_progress) {
    dispatch(updateWatchedLesson(true, lessonID));
    dispatch(updateWatchedLessonOnModule(true, lessonID));
  }
};

export const finishLesson =
  (lessonID: number, courseHash: string, markAsWatched?: boolean) => async (dispatch: any) => {
    try {
      await put({ url: `/learner/lessons/${lessonID}/finish`, baseURL: API_V4_BASE_URL });
      if (markAsWatched !== undefined) {
        dispatch(updateWatchedLesson(markAsWatched, lessonID));
        dispatch(updateWatchedLessonOnModule(markAsWatched, lessonID));
      }
    } catch (err) {
      console.log(err);
    }
  };

export const markLessonAsWatchedReducer = (lessonID: number) => async (dispatch: any) => {
  try {
    dispatch(updateWatchedLesson(true, lessonID));
    dispatch(updateWatchedLessonOnModule(true, lessonID));
  } catch (err) {
    console.log(err);
  }
};

const receiveLesson = (lesson: Object) => ({
  type: 'RECEIVE_LESSON',
  lesson: {
    fetched: true,
    ...lesson,
  },
});

export const receiveLessonError = (error: any) => ({
  type: 'RECEIVE_LESSON_ERROR',
  error,
});

export const receiveLessonFile = (urlFile: any) => ({
  type: 'RECEIVE_LESSON_FILE',
  urlFile,
});

export const receiveLessonFileError = (error: any) => ({
  type: 'RECEIVE_LESSON_FILE_ERROR',
  error,
});

export const receiveAudioFile = (audioFile: any, lessonContentId: number) => ({
  type: 'RECEIVE_AUDIO_FILE',
  audioFile,
  lessonContentId,
});

export const receiveAudioFileError = (lessonContentId: number) => ({
  type: 'RECEIVE_AUDIO_FILE_ERROR',
  lessonContentId,
});

export const fetchLesson = (lessonID: number, course: ICourse, authenticated: boolean) => async (dispatch: any) => {
  if (!lessonID) return false;
  dispatch(increaseLoading());

  try {
    const response = await get({
      url: '/learner/lessons/' + lessonID,
      baseURL: API_V4_BASE_URL,
    });

    dispatch(receiveLesson(response.data.data || []));
    if (authenticated) {
      dispatch(startLesson(lessonID, course));
    }
    if (!IS_APP) {
      dispatch(fetchUpsells(course.hash, lessonID));
    }
    dispatch(decreaseLoading());

    return response;
  } catch (error) {
    dispatch(decreaseLoading());
    dispatch(receiveLessonError(error));

    throw error;
  }
};

export const downloadFileLesson = (fileID: number) => async (dispatch: any) => {
  try {
    const response = await get({
      url: '/download/file/' + fileID,
      baseURL: API_V4_BASE_URL,
    });
    window.open(response.data);
    return response;
  } catch (error) {
    dispatch(receiveLessonFileError(error));
    throw error;
  }
};

export const downloadAudioFile = (lessonContentId: number) => async (dispatch: any) => {
  try {
    const response = await get({ url: '/download/audio/' + lessonContentId });
    dispatch(receiveAudioFile(response.data, lessonContentId));
  } catch (error) {
    dispatch(receiveAudioFileError(lessonContentId));
  }
};

export const changeLessonField = (field: string, value: string | number) => ({
  type: 'CHANGE_LESSON_FIELD',
  field,
  value,
});

export const addLessonFiles = (files: Array<any>) => ({
  type: 'ADD_LESSON_FILES',
  files,
});

export const removeLessonFile = (index: number) => ({
  type: 'REMOVE_LESSON_FILE',
  index,
});
